/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { Link, PageNotification } from '@coursera/cds-core';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import { usePartnerVariation } from 'bundles/degree-home/components/v3-dpm/context/PartnerVariation';

import _t from 'i18n!nls/degree-home';

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-400);
  `,
};

export const DegreeAuditDisclaimer: React.VFC = () => {
  const { showDegreeAuditDisclaimer, setDontShowDisclaimer } = usePartnerVariation();
  const { degreeId } = useDegreeContext();
  const track = useRetracked();

  const [showNotification, setShowNotification] = React.useState<boolean>(showDegreeAuditDisclaimer);

  const trackButton = (name: string) => {
    track({
      action: 'click',
      trackingName: name,
      trackingData: {
        degreeId,
      },
    });
  };

  const handleDismissClick = () => {
    setShowNotification(false);
    setDontShowDisclaimer();
    trackButton('dismiss');
  };

  if (!showNotification) return null;

  return (
    <PageNotification
      severity="information"
      title="This is not an official CU Boulder degree audit"
      onDismiss={handleDismissClick}
      css={styles.container}
    >
      <React.Fragment>
        {_t(
          'This page is not an official degree audit. See Buff Portal for the most accurate record of your graduation progress and contact mscs-coursera@colorado.edu with any questions.'
        )}{' '}
        <Link
          onClick={() => trackButton('go_to_buff_portal_click')}
          href="https://buffportal.colorado.edu/"
          target="_blank"
        >
          {_t('Go to Buff Portal')}
        </Link>
      </React.Fragment>
    </PageNotification>
  );
};

export default DegreeAuditDisclaimer;
